import { type Address } from 'viem';

export const OPENGRADIENT_ETH_DEVNET_RPC_URL = 'https://ogevmdevnet.opengradient.ai';
export const OPENGRADIENT_INFERENCE_CONTRACT_ADDRESS = '0xf1dc0d5Dcf2A01924faC78185B9227CF3EC839A5' satisfies Address;
export const OPENGRADIENT_SCHEDULER_CONTRACT_ADDRESS = '0x7179724De4e7FF9271FA40C0337c7f90C0508eF6' satisfies Address;
